import { UserPreferencesButton } from './UserPreferencesButton';
import { connectUserPreferencesButton } from './UserPreferencesButton.connect';

export const ConnectedUserPreferencesButton = connectUserPreferencesButton(UserPreferencesButton);
